// responsiveSize.js — pure geometry for container-relative BrandWheelLoader sizing.
//
// fix-gordon-0929-P1-wheel-loader-scales-with-space (Gordon, 2026-09-29,
// screenshot web-dev.iyuga.net/gallery/21): the ~1500x900 Gallery main area
// rendered a fixed ~56px "medium" loader in the middle of a huge wallpaper —
// "Large spaces like this should never have a Wheel Loader that small." Every
// space-filling variant now sizes off the container it fills instead of a
// pinned per-variant pixel value; the exact clamp is Gordon's own spec.
//
// Pure so it's unit-testable without mounting a component or faking a
// ResizeObserver (same separation as arcSweepEngine.js's computeFrame).
export const RESPONSIVE_MIN_PX = 48;
export const RESPONSIVE_MAX_PX = 160;
export const RESPONSIVE_SHORT_SIDE_RATIO = 0.12;

// Returns the clamped size in px, or `null` when the container has no usable
// size yet (e.g. a parent mid-layout reporting 0 — callers should fall back
// to the fixed per-variant default rather than freezing at the 48px floor).
export function computeContainerRelativeSize({
  width,
  height,
  min = RESPONSIVE_MIN_PX,
  max = RESPONSIVE_MAX_PX,
  ratio = RESPONSIVE_SHORT_SIDE_RATIO,
}) {
  const w = Number(width) || 0;
  const h = Number(height) || 0;
  if (w <= 0 || h <= 0) return null;
  const shortSide = Math.min(w, h);
  return Math.round(Math.min(max, Math.max(min, shortSide * ratio)));
}
